import { Geolocation, Map } from 'ol';
import React from 'react';

import useSnackbar from '../../../hooks/useSnackbar';

const DEFAULT_ZOOM = 13;

const useCurrentLocation = (map: Map | null | undefined): [loading: boolean, handleClick: React.MouseEventHandler] => {
  const showSnackbar = useSnackbar();
  const [loading, setLoading] = React.useState<boolean>(false);
  const [geolocation, setGeolocation] = React.useState<Geolocation | undefined>(undefined);

  const panToLocation = (location: Geolocation): void => {
    const coordinates = location?.getPosition();

    if (coordinates) {
      const view = map?.getView();
      const zoom = view?.getZoom() ?? DEFAULT_ZOOM;
      view?.animate({
        center: coordinates,
        duration: 300,
        zoom: Math.max(zoom, DEFAULT_ZOOM),
      });
    }
  };

  const start = (): void => {
    setLoading(true);

    if (!map) {
      console.error('No map available');

      return;
    }

    if (!geolocation) {
      const newGeoLocation = new Geolocation({
        projection: map.getView().getProjection(),
        trackingOptions: {
          enableHighAccuracy: true,
        },
      });
      newGeoLocation.setTracking(true);
      newGeoLocation.once('change:position', () => {
        setLoading(false);
        newGeoLocation.setTracking(false);
        panToLocation(newGeoLocation);
      });
      newGeoLocation.on('error', (err) => {
        showSnackbar('Niet gelukt om je locatie te vinden.');
        console.error('Geolocation error:', err.message);
        setLoading(false);
      });
      setGeolocation(newGeoLocation);
    }
  };

  const handleClick: React.MouseEventHandler = (event): void => {
    event.preventDefault();

    if (geolocation) {
      panToLocation(geolocation);
    } else {
      start();
    }
  };

  return [loading, handleClick];
};

export default useCurrentLocation;
